import { useMeetingContainerContext } from "../../contexts/meetingContainer/context";
import { MediaSourcePicker } from "./MediaSourcePicker"
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { RevealContainer } from "@kalyzee/kalyzee-ui";
import { MediaSourceWorkBox } from "../workBoxes/MediaSourceWorkBox";

import { MeetingSourceExtended } from "../../hooks/meeting";
import React from "react";
import clsx from "clsx";

import styles from "./SourcePickerAlwaysOpen.module.css"
import { useAppStoreDispatch } from "../../contexts/appStore/context";

export const SourcePickerAlwaysOpen = React.memo(({
  sources,
}: {
  sources: MeetingSourceExtended[];
}) => {
  const { containerAPI } = useMeetingContainerContext();
  const sourcePickerOpen = useAppStoreSelector(state => state.sourcePickerOpen);
  const isMobile = useAppStoreSelector(state => state.isMobile);
  const dispatch = useAppStoreDispatch();

  const onClose = () => dispatch("setSourcePickerOpen", false);

  // On mobile, the source picker is in the workbox overlay — don't render here
  if (isMobile) return null;

  return (
    <RevealContainer
      open={!!sourcePickerOpen}
      duration={400}
      easing="ease-in-out"
      className={clsx(styles.revealContainer, "sourcePickerReveal")}
      reverse
      hideMode="display-none"
    >
      <MediaSourceWorkBox
        onClose={onClose}
        className={styles.mediaSourcePicker}
      >
        <MediaSourcePicker
          meetingAPI={containerAPI}
          sources={sources}
          display
          style={{ padding: 0, width: 400, height: 250 }}
        />
      </MediaSourceWorkBox>
    </RevealContainer>
  );
});